export default "__VITE_ASSET__aff94a12__"